import ActionRequiredBilling from './modules/ActionRequiredBilling'
import ActionRequired from './modules/ActionRequiredService'
import ActionStepApp from './modules/ActionStepApp'
import AdHocTemplate from './modules/AdHocTemplate'
import AMAFeeCodeService from './modules/AMAFeeCodeService'
import AppointmentSearchHistoryService from './modules/AppointmentSearchHistoryService'
import AppointmentSession from './modules/AppointmentSessionService'
import Assessment from './modules/Assessment'
import Attachment from './modules/AttachmentService'
import AttachmentType from './modules/AttachmentType'
import BackgroundJob from './modules/BackgroundJob'
import Cancellation from './modules/Cancellation'
import CaseClientDetail from './modules/CaseClientDetail'
import CaseDictationReport from './modules/CaseDictationReport'
import CaseManager from './modules/CaseManagerService'
import CaseNote from './modules/CaseNote'
import CasePermission from './modules/CasePermissionService'
import CaseStatusLog from './modules/CaseStatusLogService'
import Centre from './modules/CentreService'
import Chatbot from './modules/Chatbot'
import Checklist from './modules/ChecklistService'
import Client from './modules/ClientService'
import MedicalRecord from './modules/ClinicalRecord'
import Clinical from './modules/ClinicalService'
import ClioApp from './modules/ClioApp'
import CompanyGroups from './modules/CompanyGroups'
import Company from './modules/CompanyService'
import Contractor from './modules/ContractorService'
import Correspondence from './modules/CorrespondenceService'
import Country from './modules/CountryService'
import CreditRequest from './modules/CreditRequest'
import DisbursementFunding from './modules/DisbursementFunding'
import DocumentType from './modules/DocumentTypes'
import Edition from './modules/Edition'
import EmailTemplatePreview from './modules/EmailTemplatePreviewService'
import EmailTemplate from './modules/EmailTemplateService'
import EmailTracking from './modules/EmailTrackingService'
import Eml from './modules/EmlService'
import EntityHistory from './modules/EntityHistory'
import FundingAgreement from './modules/FacilityAgreement'
import FundingRequest from './modules/FacilityRequest'
import FundingTransaction from './modules/FacilityTransaction'
import FileManager from './modules/FileManager'
import File from './modules/FileService'
import FileStatic from './modules/FileStaticService'
import FileTemplate from './modules/FileTemplate'
import FundingProvider from './modules/FundingProvider'
import HealthStatus from './modules/HealthStatusService'
import Holiday from './modules/HolidaysService'
import HourlyRate from './modules/HourlyRateService'
import IMSApprovalCodes from './modules/IMSApprovalCodes'
import InsuranceClaim from './modules/InsuranceClaim'
import Language from './modules/Language'
import LeapApp from './modules/LeapApp'
import LookupConfig from './modules/LookupConfigService'
import MagConnect from './modules/MagConnect'
import MailBox from './modules/MailBoxService'
import MarketingCampaign from './modules/MarketingCampaign'
import MatterType from './modules/MatterTypes'
import MedNeg from './modules/MedNegService'
import Migration from './modules/Migration'
import NDIS from './modules/NDIS'
import Payment from './modules/PaymentService'
import PIC from './modules/PICService'
import PMSService from './modules/PMSService'
import Account from './modules/Account'
import QuickBook from './modules/QuickBookService'
import RepaymentInvoice from './modules/RepaymentInvoice'
import ReportCorrection from './modules/ReportCorrectionService'
import ReportService from './modules/ReportService'
import RingCentral from './modules/RingCentralService'
import RolesService from './modules/RolesService'
import SaleTarget from './modules/SaleTarget'
import SearchService from './modules/SearchService'
import ServiceItem from './modules/ServiceItemService'
import ServiceProvider from './modules/ServiceProviderService'
import SmokeBallService from './modules/SmokeBallService'
import Specialist from './modules/SpecialistService'
import Supplementary from './modules/Supplementary'
import SystemConfig from './modules/SystemConfigService'
import SystemError from './modules/SystemErrorService'
import SystemInvoice from './modules/SystemInvoice'
import SystemReport from './modules/SystemReportService'
import SystemUpdate from './modules/SystemUpdate'
import Tenant from './modules/TenantService'
import UserGroup from './modules/UserGroupService'
import User from './modules/UserService'
import VideoSession from './modules/VideoSessionService'
import Xero from './modules/XeroService'
import UHG from './modules/UHGService'
import PEApp from './modules/PEApp'
import TimeTracking from './modules/TimeTracking'
import TimeBreakDown from './modules/TimeBreakDown'
import MvaService from './modules/MvaService'
import Paperwork from './modules/Paperwork'
import TalkingPoint from './modules/TalkingPointService'
import TalkingPointCategory from './modules/TalkingPointCategoryService'
import TalkingPointState from './modules/TalkingPointStateService'
import OnetimeAccess from './modules/OnetimeAccess'
import NDISServiceItem from './modules/NDISServiceItemService'
import VideoMeeting from './modules/VideoMeetingService'
import Notification from './modules/NotificationService'
import Tpd from './modules/TpdService'
import PdfService from './modules/PdfService'
import TokenLifetimeSettings from './modules/TokenLifetimeSettingsService'

export const ApiService = {
  OnetimeAccess,
  ActionRequired,
  PIC,
  Chatbot,
  MagConnect,
  Assessment,
  AppointmentSession,
  AppointmentSearchHistoryService,
  Attachment,
  CaseClientDetail,
  CaseManager,
  CaseNote,
  CaseStatusLog,
  Centre,
  Client,
  Company,
  CompanyGroups,
  ServiceProvider,
  Contractor,
  Correspondence,
  Country,
  EmailTemplate,
  EmailTemplatePreview,
  HourlyRate,
  Eml,
  LookupConfig,
  Payment,
  ServiceItem,
  Specialist,
  SystemConfig,
  User,
  UserGroup,
  VideoSession,
  AMAFeeCodeService,
  IMSApprovalCodes,
  SaleTarget,
  File,
  Account,
  ActionRequiredBilling,
  RolesService,
  ReportService,
  EntityHistory,
  Supplementary,
  Clinical,
  MedicalRecord,
  FileStatic,
  MailBox,
  MarketingCampaign,
  SearchService,
  MedNeg,
  Tenant,
  QuickBook,
  Xero,
  RingCentral,
  UHG,
  FileTemplate,
  CaseDictationReport,
  ClioApp,
  LeapApp,
  PEApp,
  ActionStepApp,
  FundingRequest,
  FundingAgreement,
  SmokeBallService,
  FundingTransaction,
  DisbursementFunding,
  CreditRequest,
  Checklist,
  FundingProvider,
  TimeTracking,
  NDIS,
  EmailTracking,
  HealthStatus,
  InsuranceClaim,
  Language,
  AttachmentType,
  SystemReport,
  SystemUpdate,
  SystemInvoice,
  TimeBreakDown,
  Edition,
  Migration,
  PMSService,
  MvaService,
  Paperwork,
  Cancellation,
  SystemError,
  DocumentType,
  MatterType,
  TalkingPoint,
  TalkingPointCategory,
  TalkingPointState,
  CasePermission,
  NDISServiceItem,
  VideoMeeting,
  RepaymentInvoice,
  BackgroundJob,
  Holiday,
  AdHocTemplate,
  Notification,
  Tpd,
  FileManager,
  ReportCorrection,
  PdfService,
  TokenLifetimeSettings,
}
